/**
 * @module
 */
import {BUILD} from '../service/env.js';

ESBUILD_EVENTSOURCE: if (BUILD.enableEventSource) {
  const {EventSource, setTimeout, location, document} = window;
  const {OPEN, CONNECTING} = EventSource;
  const {debug, info, log, warn} = console;
  const thing = 'The esbuild event source';

  /** @type {EventSource | undefined} */
  let es;
  let retryCount = 0;
  let deferred = false;

  const create = () => {
    es = new EventSource(BUILD.eventSourceUrl);
    es.onopen = onOpen;
    es.onerror = onError;
    es.addEventListener('change', reload);
  };

  const isOnline = () => es?.readyState == OPEN || es?.readyState == CONNECTING;

  const onOpen = () => {
    if (!retryCount) {
      debug(`%c${thing} is online.`, CONSOLE_STYLE, es);
    } else {
      log(`%c${thing} is online again. Reload just for the case.`, CONSOLE_STYLE);
      setTimeout(reload, 1000);
    }
  };

  const onError = () => {
    const timeout = Math.min(30000, (++retryCount) ** 2 * 50);
    const secs = (timeout / 1000).toFixed(1);
    warn(`%c${thing} is lost. Search and rescue in %ss...`, CONSOLE_STYLE, secs);
    setTimeout(create, timeout);
  };

  const reload = () => {
    if (document.hidden) {
      deferred = true;
      return;
    }

    deferred = false;
    info(`%c${thing} reloads the location now!`, CONSOLE_STYLE);
    es?.close();
    location.reload();
  };

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && deferred) {
      reload();
    }
  });

  window.addEventListener('beforeunload', () => {
    if (isOnline()) {
      debug(`%c${thing} goes offline before window unload.`, CONSOLE_STYLE);
      es?.close();
    }
  });

  create();
}

configDebug.$inject = ['$compileProvider', '$logProvider'];
/**
 * @param {angular.ICompileProvider} $compileProvider -
 * @param {angular.ILogProvider} $logProvider -
 */
export function configDebug($compileProvider, $logProvider) {
  DEBUG: if (BUILD.enableDebug) {
    console.debug('%cAngularJS debug mode is enabled.', CONSOLE_STYLE);
    return;
  }

  $compileProvider.debugInfoEnabled(false);
  $logProvider.debugEnabled(false);
}

/**
 * Red Cross Color
 */
const CONSOLE_STYLE =
  'display: inline-block;' + //
  'background: white;' +
  'color: #e4010b;' +
  'font-weight: bold;' +
  'padding: 0 1pc;' +
  'border-radius:1pt';

DEBUG: {
  console.debug('%cJavaScript source includes "DEBUG" labelled statements.', CONSOLE_STYLE);

  let assertsAreNotIncluded = true;
  ASSERT: assertsAreNotIncluded = false;

  if (assertsAreNotIncluded) {
    console.info('%cBut "ASSERT" labelled are not!', CONSOLE_STYLE);
  }
}
